import { uploadMedia } from '../api/mediaApi';

const useMediaUpload = (setUserMedia, setErrorMessages, fileList) => {
    const handleMeidaUpload = async (files) => {
        let newErrorMessages = [];
        setErrorMessages && setErrorMessages([]);

        if (!files) return;

        for (const file of files) {
            const isAllowedFileType = Object.keys(fileList).some((pattern) =>
                new RegExp(pattern).test(file.type)
            );

            if (!isAllowedFileType) {
                newErrorMessages.push('This file type is not supported');
                continue;
            }

            // Stable local identifiers
            const tempId = Date.now() + Math.random();
            const mediaIndex = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

            const placeholderMedia = {
                id: tempId,          // local temp id
                name: file.name,
                type: file.type,
                size: file.size,
                url: '',
                createdAt: '',
                index: mediaIndex,
                isLoading: true,
                isError: false
            };

            // 1️⃣ Add placeholder
            setUserMedia((prev) => [placeholderMedia, ...prev]);

            try {
                // 2️⃣ Upload
                const uploadedMediaData = await uploadMedia(file, mediaIndex);

                // 3️⃣ Update placeholder on success
                setUserMedia((prev) =>
                    prev.map((media) =>
                        media.id === tempId
                            ? {
                                ...media,
                                ...uploadedMediaData,
                                isLoading: false
                            }
                            : media
                    )
                );
            } catch (error) {
                console.error('Upload failed:', error);

                newErrorMessages.push(
                    `Failed to upload ${file.name}`
                );

                // 4️⃣ Remove placeholder on failure
                setUserMedia((prev) =>
                    prev.filter((media) => media.id !== tempId)
                );
            }
        }

        if (newErrorMessages.length) {
            console.log(newErrorMessages);
            setErrorMessages && setErrorMessages(newErrorMessages);
        }
    };

    return { handleMeidaUpload };
};

export default useMediaUpload;